import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import { SET_PLACEMENT_DATA, SET_PLACEMENT_FETCHING_LOADING } from './mutations';
import { getPlacement as getPlacementGetter, getServicePlacements, getServicePlacementsBySlug } from './getters';
import api from '@/api';
import { setVersionOfPlacement } from './modules/versions/actions';
import { getServiceBySlug } from '../apps/getters';
import { getServiceDataBySlug } from '../apps/actions';

const buildPlacementActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const getPlacement = buildPlacementActionObject('getPlacement');
export const setPlacements = buildPlacementActionObject('setPlacements');
export const setPlacement = buildPlacementActionObject('setPlacement');
export const getPlacementsOfService = buildPlacementActionObject('getPlacementsOfService');
export const getPlacementsOfServiceBySlug = buildPlacementActionObject('getPlacementsOfServiceBySlug');
const _fetchPlacementsOfService = buildPlacementActionObject('_fetchPlacementsOfService');
const _fetchPlacement = buildPlacementActionObject('_fetchPlacement');
export const setPlacementFetchingLoading = buildPlacementActionObject('setPlacementFetchingLoading');

const promises = {}; // { [serviceId/slug]: Promise }

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [setPlacements.action]({ dispatch }, payload) {
		const { data } = payload;
		await Promise.all(data.map((placement) => dispatch(setPlacement.action, { data: placement })));
	},
	async [setPlacement.action]({ commit, dispatch }, payload) {
		const { data } = payload;
		const { versions, ...placement } = data;
		await Promise.all(
			versions.map((placementVersion) =>
				dispatch(
					setVersionOfPlacement.fullPath,
					{ placementId: placement.id, placementVersion },
					{
						root: true,
					}
				)
			)
		);
		commit(SET_PLACEMENT_DATA, { key: placement.id, value: placement });
	},
	async [getPlacement.action]({ dispatch, getters }, { id, forceGet }) {
		const dataIsMissing = !getters[getPlacementGetter.getter](id);
		const needToGet = dataIsMissing || forceGet;
		if (needToGet) {
			const promiseKey = `placement-${id}`;
			return await (promises[promiseKey] || (promises[promiseKey] = dispatch(_fetchPlacement.action, { id })));
		}
	},
	async [_fetchPlacement.action]({ dispatch }, { id }) {
		const placementRes = await api.getPlacement(id);
		return dispatch(setPlacement.action, { data: placementRes });
	},
	async [getPlacementsOfService.action]({ dispatch, getters }, payload) {
		const { serviceId, forceGet = true } = payload;
		const dataIsMissing = getters[getServicePlacements.getter](serviceId).length === 0;
		const needToGet = dataIsMissing || forceGet;
		if (needToGet) {
			const promiseKey = `service-${serviceId}`;
			await (promises[promiseKey] || (promises[promiseKey] = dispatch(_fetchPlacementsOfService.action, { serviceId })));
		}
	},
	async [getPlacementsOfServiceBySlug.action]({ dispatch, getters, rootGetters }, { slug, forceGet = true }) {
		const dataIsMissing = getters[getServicePlacementsBySlug.getter](slug).length === 0;
		const needToGet = dataIsMissing || forceGet;
		if (needToGet) {
			await dispatch(getServiceDataBySlug.fullPath, { slug }, { root: true });
			const service = rootGetters[getServiceBySlug.fullPath](slug);
			return dispatch(getPlacementsOfService.action, { serviceId: service.id });
			// const promiseKey = `service-${slug}`;
			// return await (promises[promiseKey] || (promises[promiseKey] = dispatch(_fetchPlacementsOfService.action, { serviceId: slug })));
		}
	},
	async [_fetchPlacementsOfService.action]({ dispatch }, payload) {
		const { serviceId } = payload;
		await dispatch(setPlacementFetchingLoading.action, true);
		const placementsRes = await api.getPlacementsOfService(serviceId);
		await dispatch(setPlacementFetchingLoading.action, false);
		await dispatch(setPlacements.action, { data: placementsRes });
	},
	[setPlacementFetchingLoading.action]({ commit }, value) {
		commit(SET_PLACEMENT_FETCHING_LOADING, value);
	},
};

export default actions;
